import React from 'react'
import './style.scss'
import Menu from '../../components/Menu'
import CompanyList from '../../Company/components/CompaniesList'
import Footer from '../../components/Footer'

const CompanyReputation = () => {

  return (
    <>
      <Menu />      
      <CompanyList/>      
      <Footer />
    </>
  )
}

export default CompanyReputation;

